import React from 'react';
import { FrameButtons, MiniFrame } from '@code-hike/mini-frame';
import { useClasser } from '@code-hike/classer';
import { useSpring } from 'use-spring';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}

function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}

function Back() {
  var c = useClasser("ch-browser");
  return React.createElement("svg", {
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet",
    height: "1em",
    viewBox: "13 10 14 23",
    className: c("button", "back-button")
  }, React.createElement("g", null, React.createElement("path", {
    d: "m26.5 12.1q0 0.3-0.2 0.6l-8.8 8.7 8.8 8.8q0.2 0.2 0.2 0.5t-0.2 0.5l-1.1 1.1q-0.3 0.3-0.6 0.3t-0.5-0.3l-10.4-10.4q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.2 0.5-0.2t0.6 0.2l1.1 1.1q0.2 0.2 0.2 0.5z"
  })));
}

function Forward() {
  var c = useClasser("ch-browser");
  return React.createElement("svg", {
    fill: "currentColor",
    preserveAspectRatio: "xMidYMid meet",
    height: "1em",
    viewBox: "13 10 14 23",
    className: c("button", "forward-button")
  }, React.createElement("g", null, React.createElement("path", {
    d: "m26.3 21.4q0 0.3-0.2 0.5l-10.4 10.4q-0.3 0.3-0.6 0.3t-0.5-0.3l-1.1-1.1q-0.2-0.2-0.2-0.5t0.2-0.5l8.8-8.8-8.8-8.7q-0.2-0.3-0.2-0.6t0.2-0.5l1.1-1.1q0.3-0.2 0.5-0.2t0.6 0.2l10.4 10.4q0.2 0.2 0.2 0.5z"
  })));
}

function Open(_a) {
  var href = _a.href;
  var c = useClasser("ch-browser");
  return React.createElement("a", {
    className: c("button", "open-button"),
    title: "Open in new tab",
    href: href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement("svg", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "3 3 18 18",
    height: "1em",
    width: "1em",
    className: c("open-icon"),
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
  })));
}

function TitleBar(_a) {
  var url = _a.url,
      linkUrl = _a.linkUrl;
  return React.createElement(React.Fragment, null, React.createElement(FrameButtons, null), React.createElement(Back, null), React.createElement(Forward, null), React.createElement("input", {
    value: url || "",
    readOnly: true
  }), React.createElement(Open, {
    href: linkUrl
  }));
}

function useSteps$1(steps) {
  return React.useMemo(function () {
    if (!steps) {
      return [{
        zoom: 1
      }];
    }

    return steps.map(function (step) {
      var _a = transformUrl(step.url, step.loadUrl, step.prependOrigin),
          displayUrl = _a.displayUrl,
          loadUrl = _a.loadUrl;

      return {
        zoom: step.zoom || 1,
        displayUrl: displayUrl,
        loadUrl: loadUrl,
        children: step.children
      };
    });
  }, [steps]);
}

function transformUrl(url, loadUrl, prependOrigin) {
  var currentOrigin = typeof window !== "undefined" ? window.origin : "";
  var displayUrl = url && prependOrigin === true ? currentOrigin + url : url;
  return {
    displayUrl: displayUrl,
    loadUrl: loadUrl || displayUrl
  };
}

var MiniBrowserHike = React.forwardRef(MiniBrowserWithRef);

function MiniBrowserWithRef(_a, ref) {
  var _b = _a.progress,
      progress = _b === void 0 ? 0 : _b;
  _a.backward;

  var ogSteps = _a.steps,
      _d = _a.transition,
      transition = _d === void 0 ? "none" : _d,
      classes = _a.classes,
      props = __rest(_a, ["progress", "backward", "steps", "transition", "classes"]);

  var c = useClasser("ch-mini-browser", classes);
  var steps = useSteps$1(ogSteps);
  var stepIndex = Math.round(progress);
  var _e = steps[stepIndex],
      zoom = _e.zoom,
      displayUrl = _e.displayUrl,
      loadUrl = _e.loadUrl,
      children = _e.children;
  return React.createElement(MiniFrame, _assign({}, props, {
    zoom: zoom,
    className: c("") + " " + (props.className || ""),
    style: _assign(_assign({}, transitionStyle({
      progress: progress,
      transition: transition
    })), props.style),
    classes: classes,
    titleBar: React.createElement(TitleBar, {
      url: displayUrl,
      linkUrl: loadUrl
    })
  }), children || React.createElement("iframe", {
    ref: ref,
    src: loadUrl
  }));
}

function transitionStyle(_a) {
  var progress = _a.progress,
      transition = _a.transition;

  if (transition === "slide") {
    var X = 50;
    var t = progress - Math.floor(progress);
    var x = t <= 0.5 ? -X * t : X - X * t;
    var o = Math.abs(t - 0.5) * 2;
    return {
      transform: "translateX(" + x + "px)",
      opacity: o * o
    };
  }

  return {};
}

function MiniBrowser(_a) {
  var url = _a.url,
      loadUrl = _a.loadUrl,
      prependOrigin = _a.prependOrigin,
      children = _a.children,
      zoom = _a.zoom,
      rest = __rest(_a, ["url", "loadUrl", "prependOrigin", "children", "zoom"]);

  var _b = __read(useSteps({
    url: url,
    loadUrl: loadUrl,
    prependOrigin: prependOrigin,
    children: children,
    zoom: zoom
  }), 2),
      steps = _b[0],
      progress = _b[1];

  return React.createElement(MiniBrowserHike, _assign({}, rest, {
    steps: steps,
    progress: progress
  }));
}

function useSteps(_a) {
  var url = _a.url,
      loadUrl = _a.loadUrl,
      prependOrigin = _a.prependOrigin,
      children = _a.children,
      zoom = _a.zoom;

  var _b = __read(React.useState({
    target: 0,
    steps: [{
      url: url,
      loadUrl: loadUrl,
      prependOrigin: prependOrigin,
      children: children,
      zoom: zoom
    }]
  }), 2),
      state = _b[0],
      setState = _b[1];

  React.useEffect(function () {
    var last = state.steps[state.steps.length - 1];

    if (last.url !== url || last.loadUrl !== loadUrl || last.prependOrigin !== prependOrigin || last.children !== children) {
      setState(function (s) {
        return {
          target: s.target + 1,
          steps: __spread(s.steps, [{
            url: url,
            loadUrl: loadUrl,
            prependOrigin: prependOrigin,
            children: children,
            zoom: zoom
          }])
        };
      });
    }
  }, [url, loadUrl, prependOrigin, children, zoom]);

  var _c = __read(useSpring(state.target, {
    stiffness: 100,
    decimals: 3
  }), 1),
      progress = _c[0];

  return [state.steps, progress];
}

export { MiniBrowser, MiniBrowserHike };